import { Trans } from '@lingui/macro';
import type { StoreLocale } from '@store-constants';
import { isChLocale, WELLASTORE_PROFESSIONAL_URL } from '@store-constants';
import clsx from 'clsx';
import Link from 'next/link';
import styles from './LoginForProPriceLabel.module.scss';

export const LoginForProPriceLabel = ({
  separatePriceForPro,
  locale,
  signedIn,
  redirectToWsUrl,
}: {
  separatePriceForPro: boolean;
  locale: StoreLocale;
  signedIn?: boolean;
  proCustomer?: boolean;
  redirectToWsUrl?: string;
}) => {
  // logic is different for en-GB locale than for others
  if (locale === 'en-GB') {
    if (redirectToWsUrl) {
      return (
        <div className={styles.proPriceLogin}>
          <Link
            className={clsx(styles.proPriceLogin__link, 'text-body-small')}
            href={redirectToWsUrl ?? WELLASTORE_PROFESSIONAL_URL[locale]}
            target="_blank"
          >
            <Trans id="product.separateProPrice.goToWellaStore">
              Are you a Nail Professional? Buy on Wellastore.com
            </Trans>
          </Link>
        </div>
      );
    }
    return null;
  }

  if (
    (isChLocale(locale) && separatePriceForPro) ||
    (locale === 'de-DE' && redirectToWsUrl)
  ) {
    return (
      <div className={styles.proPriceLogin}>
        <Link
          className={clsx(styles.proPriceLogin__link, 'text-body-small')}
          href={redirectToWsUrl ?? WELLASTORE_PROFESSIONAL_URL[locale]}
          target="_blank"
        >
          <Trans id="product.separateProPrice.goToWellaStore">
            Are you a Nail Professional? Buy on Wellastore.com
          </Trans>
        </Link>
      </div>
    );
  }

  if (signedIn || !separatePriceForPro) return null;

  return (
    <div className={styles.proPriceLogin}>
      <Link
        className={clsx(styles.proPriceLogin__link, 'text-body-small')}
        href={'/account/login'}
      >
        <Trans id="product.separateProPrice.loginMessage">
          Log in to see Professional pricing
        </Trans>
      </Link>
    </div>
  );
};
